export function makeUiOrderId(path, index) {
  return !path || path === "root" ? index.toString() : `${path}.${index}`;
}

export function makeIdPattern(path, index) {
  return makeUiOrderId(path, index).replace(new RegExp("\\.", "g"), "\\.");
}
